import { makeStyles } from '@material-ui/core/styles';

export const UserSessionTimeoutMessageStyles = makeStyles((theme) => ({
  title: {
    marginBottom: '1.25rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
    },
  },
  content: {
    fontWeight: 600,
    marginBottom: '1.75rem',
  },
}));
